// @flow

import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const COLOR_MAP = {
  black: '#171717',
  white: '#ffffff',
};

type Props = {
  color?: 'black' | 'white',
  variant?: 'default' | 'checkbox',
  [string]: any,
};

const Checkmark = (props: Props) => {
  const { color = 'black', variant = 'default', ...iconProps } = props;
  const fill = COLOR_MAP[color];
  const isCheckboxVariant = variant === 'checkbox';

  return (
    <SvgIcon viewBox={isCheckboxVariant ? '0 0 12 10' : '-4 -3 21 15'} {...iconProps}>
      {isCheckboxVariant ? (
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M11.5 1.10012L4.53815 9.51448L0 5.39084L1.16057 4.11361L4.36086 7.02158L10.1704 0L11.5 1.10012Z"
          fill={fill}
        />
      ) : (
        <path
          d="M2.02228 4.42975L5.57404 7.47065L11.8698 0.5L13 1.29549L5.68144 9.38889L1 5.36545L2.02228 4.42975Z"
          fill={fill}
          stroke={fill}
        />
      )}
    </SvgIcon>
  );
};

export default Checkmark;
